module.exports = "<!-- <div *ngFor=\"let item of room\">\n  <p>{{item.scene.a.actionOptions}}</p>\n\n</div> -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/test-database/test-database.component.html
// module id = ../../../../../src/app/test-database/test-database.component.html
// module chunks = main